import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "@/components/ui/accordion";

const FAQS = [
  { q: "What does CS Certified mean?", a: "CS Certified cars have passed Carz Swag's in-house multi-point inspection covering engine, transmission, exterior, interior, electricals, tyres, and documentation. The exact inspection details are shown on each certified car's detail page." },
  { q: "Where is the Carz Swag showroom?", a: "We are located in Vikaspuri, Delhi. Our business hours and address are on the Contact page." },
  { q: "Can I book a test drive before buying?", a: "Yes. Every available car has a 'Book Test Drive' option. Submit the form and our team will coordinate a time with you." },
  { q: "Do you offer car loans?", a: "We work with established banks and NBFCs. Submit a loan enquiry and our finance desk will walk you through tenure, rate and documentation." },
  { q: "How do I sell my car to Carz Swag?", a: "Fill the Sell Your Car form. Our team will inspect the vehicle and provide an honest offer. Paperwork is handled by us." },
  { q: "Is the price negotiable?", a: "Prices are set based on car condition, demand and market comparables. You're welcome to speak to our team for the best offer." },
];

export default function FAQPage() {
  return (
    <div className="cs-container py-10 max-w-3xl" data-testid="faq-page">
      <h1 className="font-display font-extrabold text-3xl sm:text-4xl text-gray-900">Frequently Asked Questions</h1>
      <Accordion type="single" collapsible className="mt-8">
        {FAQS.map((f, i) => (
          <AccordionItem key={i} value={`q${i}`}>
            <AccordionTrigger className="text-left font-display font-bold">{f.q}</AccordionTrigger>
            <AccordionContent className="text-gray-600 leading-relaxed">{f.a}</AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  );
}
